<template>
  <textarea :id="id" :value="value"></textarea>
</template>
<script>
// Import TinyMCE
import tinymce from "tinymce/tinymce";
import "./index.js";
const INIT = 0;
const CHANGED = 2;
//本地              该路径会影响邮件模板中的富文本编辑器
// tinymce.baseURL = "../";
//测试
tinymce.baseURL = "../zpm";
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    setting: {},
  },
  watch: {
    value: function (val) {
      if (this.status === INIT || tinymce.activeEditor.getContent() !== val) {
        tinymce.activeEditor.setContent(val);
      }
      this.status = CHANGED;
    },
  },
  data: function () {
    return {
      status: INIT,
      id: "editor-" + new Date().getMilliseconds(),
    };
  },
  methods: {},
  mounted: function () {
    // tinymce.PluginManager.load('powerpaste', '/static/plugins/powerpaste/plugin.min.js')
    const _this = this;
    const setting = {
      selector: "#" + _this.id,
      language: "zh_CN",
      plugins: "-powerpaste",
      powerpaste_word_import: "merge",
      powerpaste_html_import: "merge",
      init_instance_callback: function (editor) {
        editor.on("input change undo redo", () => {
          let content = editor.getContent();
          _this.$emit("input", content);
          _this.$emit("getOutHTML", editor.dom.doc);
        });
      },
    };
    Object.assign(setting, _this.setting);
    tinymce.init(setting);
  },
  beforeDestroy: function () {
    tinymce.get(this.id).destroy();
  },
};
</script>